<template>
  <div class="use-case-container">
    <b-row>
      <b-col cols="12" col-xl="6">
        <div class="logo-container">
          <div class="symbol">
            <lottie-icon
                style="vertical-align: middle"
                :icon="icon"
                animate="hover"
                size="medium"
            ></lottie-icon>
          </div>
          <div class="heading">
            <h3 class="upper">
              Use case
              <small>KI-gestützte Prozessführung in der Prozessindustrie </small>
            </h3>
          </div>
        </div>


      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" lg="6">
        <table class="use-case-table mb-5">
          <tbody>
          <tr>
            <th rowspan="2">Typ</th>
            <td>
              Es existieren zwei Teilaufgaben<br/>
              <div class="cell-head" style="display: inline-block">
                (1)<small>:</small>
              </div>
              KI-gestützte Analyse (Zustandserkennung über Bilddaten)
            </td>
          </tr>
          <tr>
            <td>
              <div class="cell-head" style="display: inline-block">
                (2)<small>:</small>
              </div>
              KI-gestützte Feedback-Steuerung (Optimale Betriebsverläufe)
            </td>
          </tr>
          </tbody>
          <tbody>
          <tr>
            <th>Kritikalität</th>
            <td>Sehr hoch (Potenzial von Unfällen/Störfällen)</td>
          </tr>
          </tbody>
          <tbody>
          <tr>
            <th>Datentypen</th>
            <td>Numerische Daten (Sensordaten, Betriebsparameter), Bilddaten</td>
          </tr>
          </tbody>

          <tbody>
          <tr>
            <th rowspan="2">Typische KI-Modelle</th>
            <td>
              <div class="cell-head" style="display: inline-block">
                Für (1)<small>:</small>
              </div>
              neuronale Netze, Random Forest(beide Erklärbarkeitsdefizite bzw. BlackBox)
            </td>
          </tr>
          <tr>
            <td>
              <div class="cell-head" style="display: inline-block">
                Für (2)<small>:</small>
              </div>
              Reinforcement Learning (modellprädiktive Regelung auf Basis hybrider Modelle) (zumindest weitgehend
              erklärbar)
            </td>
          </tr>
          </tbody>
          <tbody class="separator-top">
          <tr>
            <th rowspan="2">
              (Wichtigste) Zielgruppen<br/>
              <small>und jeweils übergeordnete Ziele für die Nutzung erklärbarer KI</small>
            </th>
            <td>
              <div class="cell-head">
                Domänenexpert:innen<small> (Betriebspersonal) und</small> Entwickler:innen
                <small>(Prozessführung):</small>
              </div>
              Konfidenz (Robustheit, Stabilität, Vulnerabilität) bestimmen,Kausalitätsbeziehungen finden,
              Informationsgewinn erhöhen (Vereinfachung), Interaktionsmöglichkeiten verbessern (insb. für
              Domänen-experten/-innen)
            </td>
          </tr>
          <tr>
            <td class="separator-top">
              <div class="cell-head">
                Zulassende Behörden:
              </div>
              „Nachvollziehbarkeit“ und Schutzkonzept prüfen
            </td>
          </tr>
          </tbody>
          <tbody>
          <tr>
            <th rowspan="2">Konkrete Anforderungen<br/>
              an Erklärbarkeit
            </th>
            <td>
              <div class="cell-head">
                Domänenexpert:innen<small> (Betriebspersonal)</small>
              </div>
              Erklärbarkeit von Einzelentscheidungen (lokale Erklärbarkeit)
            </td>
          </tr>
          <tr>
            <td class="separator-top">
              <div class="cell-head">
                Zulassende Behörden<small> und</small> Entwickler:innen<small> (Prozessführung):</small>
              </div>
              Einzelentscheidungserklärungen und Modellerklärungen (lokale und globale Erklärbarkeit)
            </td>
          </tr>
          </tbody>
          <tbody>
          <tr>
            <th rowspan="2">Geeignete Erklärungsstrategien</th>
            <td>
              <div class="cell-head" style="display: inline-block">
                Für (1)
              </div>
              Post hoc-Erklärungen, z. B. LIME
            </td>
          </tr>
          <tr>
            <td>
              <div class="cell-head" style="display: inline-block">
                Für (2)
              </div>
              Ante-hoc-Erklärungen („kontrollierte“ Einbindung der Black-Box-Komponenten mittels hybrider Modellierung)
            </td>
          </tr>
          </tbody>
        </table>
      </b-col>
      <b-col cols="12" lg="6" class="use-case-text">
        <markdown-it-vue-light
            ref="markdown"
            :content="content"
        >

        </markdown-it-vue-light>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {BRow, BCol} from 'bootstrap-vue';
import MarkdownItVueLight from '@/components/MarkdownItVueLighter/markdown-it-vue-light'
import LottieIcon from "@/components/Lottie/LottieIcon";

require('markdown-it-footnote');

import axios from "axios";

export default {
  name: "UseCase4",
  components: {
    BRow, BCol,
    MarkdownItVueLight,
    LottieIcon
  },
  data() {
    return {
      content: "",
      icon: "milch",
      file: "story/usecase/usecase4.md",
    }
  },
  mounted() {
    axios.get(this.file).then(({data}) => {
      return this.content = data;
    });
  },
}
</script>

<style scoped lang="scss">

</style>